import { render, staticRenderFns } from "./NotesForm.vue?vue&type=template&id=5ac15c52"
import script from "./NotesForm.vue?vue&type=script&lang=js"
export * from "./NotesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports